import { createContext, useCallback, useContext } from 'react';
import useApiService from './ApiService';
import CONFIG from './CONFIG';
import { buildUrl } from '../utils/buildQuery';
import { normalizeDate } from '../utils/formatDate';

const ChatAnalyticsApiContext = createContext(null);

export function ChatAnalyticsApiProvider({ children }) {
  const { get } = useApiService(CONFIG.SERVER_CHANNEL);

  const getTotalChatAnalytics = useCallback(
    async (start_date, end_date) => {
      try {
        const url = buildUrl('/v1/analytics/channel', {
          start_date: normalizeDate(start_date),
          end_date: normalizeDate(end_date),
        });

        const response = await get(url);
        return response.data;
      } catch (error) {
        console.error('Error fetching total chat analytics:', error);
        throw error;
      }
    },
    [get, buildUrl],
  );

  const getDetailedChatAnalytics = useCallback(
    async (start_date, end_date, skip, limit) => {
      try {
        const url = buildUrl('/v1/analytics/channel/detailed', {
          start_date: normalizeDate(start_date),
          end_date: normalizeDate(end_date),
          skip,
          limit,
        });

        const response = await get(url);
        return response.data;
      } catch (error) {
        console.error('Error fetching detailed chat analytics:', error);
        throw error;
      }
    },
    [get, buildUrl],
  );

  return (
    <ChatAnalyticsApiContext.Provider
      value={{
        getTotalChatAnalytics,
        getDetailedChatAnalytics,
      }}
    >
      {children}
    </ChatAnalyticsApiContext.Provider>
  );
}

export function useChatAnalyticsApi() {
  const context = useContext(ChatAnalyticsApiContext);
  if (!context) {
    throw new Error('useChatAnalyticsApi must be used within a ChatAnalyticsApiProvider');
  }
  return context;
}
